import { useGetProcessInfo } from '@/hooks/useGetProcessInfo.util.ts';
import { useMobileMediaQuery } from '@/utils/useMobileMediaQuery.ts';
import FinalMessageDesktop from '@/views/process/components/skillsAssessmentCollectedPage/FinalMessageDesktop.tsx';
import FinalMessageMobile from '@/views/process/components/skillsAssessmentCollectedPage/FinalMessageMobile.tsx';
import React from 'react';

const SkillsAssessmentCollectedPage: React.FC = () => {
  const isMobile = useMobileMediaQuery();
  const { processInfo } = useGetProcessInfo();

  const handleFinish = (e: React.FormEvent) => {
    e.preventDefault();
    if (processInfo?.recruitmentUrl) {
      window.location.href = processInfo?.recruitmentUrl;
    }
  };

  return isMobile ? (
    <FinalMessageMobile handleFinish={handleFinish} processInfo={processInfo} />
  ) : (
    <FinalMessageDesktop handleFinish={handleFinish} processInfo={processInfo} />
  );
};

export default SkillsAssessmentCollectedPage;
